import React, {ReactElement} from 'react';
import {LinearProgress} from '@mui/material';
import './index.scss';

type OrderStatusBarProps = {
  header?: JSX.Element | JSX.Element[];
  percentage: number;
  children?: JSX.Element | JSX.Element[];
};

const OrderStatusBar: React.FC<OrderStatusBarProps> = ({
  header,
  percentage,
  children
}: OrderStatusBarProps): ReactElement => {
  const OrderProgressBar = () => {
    return <LinearProgress variant="determinate" value={percentage} />;
  };

  return (
    <div className="progressBar">
      {header || null}
      <div className="progressBar-progress">
        <OrderProgressBar />
      </div>
      <div className="progressBar-content">{children}</div>
    </div>
  );
};

OrderStatusBar.defaultProps = {
  header: undefined,
  children: undefined
};

export default OrderStatusBar;
